import {
  FC, useEffect, useMemo, useRef, useState,
} from 'react'
import { Form, Formik } from 'formik'
import { useDispatch } from 'react-redux'
import * as Yup from 'yup'

import style from '@src/pages/UserPageGame/GameForm.module.scss'
import { Button } from '@src/components/Button/Button'
import { AppDispatch } from '@src/store/store'
import { FieldFormik } from '@src/components/common/FieldFormik/FieldFormik'
import { validateForm } from '@src/messages/validateForm'
import { phoneRegexp } from '@src/lib/regex'
import { currentGame, getCurrentGameData } from '@src/store/ducks/user/thunks'
import { InfoGame } from '@src/components/PersonalInfo/InfoGame'
import cn from 'classnames'

type GameFormProps = {
    isLoading?: boolean
    consentToProcessing?: any
    behaviorRules?: any
}

export const GameForm: FC<GameFormProps> = ({ isLoading, consentToProcessing, behaviorRules }) => {
  const dispatch = useDispatch<AppDispatch>()
  const formRef = useRef<any>()
  const validationSchema = useMemo(() => (
    Yup.object().shape({
      surname: Yup.string().required(validateForm.required),
      name: Yup.string().required(validateForm.required),
      fatherName: Yup.string(),
      contractNumber: Yup.string().matches(/^[0-9]+$/, 'Номер лицевого счета (номер договора):\n должен содержать только цифры').required(validateForm.required).typeError('Логин должен содержать только числа'),
      phone: Yup.string().matches(phoneRegexp, validateForm.phone).required(validateForm.required),
    })
  ), [])
  useEffect(() => {
    dispatch(getCurrentGameData())
  }, [dispatch])
  const initialValues = useMemo(() => ({
    surname: '',
    name: '',
    fatherName: '',
    phone: '',
    contractNumber: '',
  }), [])
  const [isFirstCheckboxChecked, setIsFirstCheckboxChecked] = useState(false)
  const [isSecondCheckboxChecked, setIsSecondCheckboxChecked] = useState(false)

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={(data, { resetForm }) => {
        dispatch(currentGame(data))
        resetForm()
        setIsFirstCheckboxChecked(false)
        setIsSecondCheckboxChecked(false)
      }}
            // onSubmit={({ surname, name, father_name, phone, contract_number }) => {
            //   dispatch(currentGame(surname, name, father_name, phone, contract_number))
      validationSchema={validationSchema}
      innerRef={formRef}
      enableReinitialize
    >
      {() => (
        <Form className={style.gameForm}>
          <div className={cn(style.box_1)}>
            <FieldFormik
              name="surname"
              placeholder="Иванов"
              label="Фамилия"
            />
            <FieldFormik
              name="name"
              placeholder="Иван"
              label="Имя"
            />
            <FieldFormik
              name="fatherName"
              placeholder="Иванович"
              label="Отчество (если таковое имеется):"
            />
            <FieldFormik
              name="contractNumber"
              placeholder="ХХХХХХХХХ"
              label="Номер лицевого счета (номер договора):"
            />
            <FieldFormik
              name="phone"
              placeholder="+375 (ХХ) ХХХ ХХ ХХ"
              mask="+{375} (00) 000-00-00"
              label="Введите ваш номер телефона"
            />

          </div>
          <InfoGame
            checkBoxName="checkBoxRuleInFirstInfoGame"
            game
            name="Участвовать"
            checked={isFirstCheckboxChecked}
            onchange={() => setIsFirstCheckboxChecked(!isFirstCheckboxChecked)}
            url={behaviorRules}
          />
          <InfoGame
            checkBoxName="checkBoxRuleInSecondInfoGame"
            name="Участвовать"
            checked={isSecondCheckboxChecked}
            onchange={() => setIsSecondCheckboxChecked(!isSecondCheckboxChecked)}
            url={consentToProcessing}
          />
          <div className={`${style.btn}`}>
            <Button
              disabled={!(isFirstCheckboxChecked && isSecondCheckboxChecked)}
              loading={isLoading}
              htmlType="submit"
              type="primary"
              className={style.btnSize}
            >
              Участвовать
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  )
}
